import { DateFormats } from 'UI/constants/defaults';

export const DEFAULT_TIME_PICKER_PROPS = {
  isClearable: true,
  withTime: true,
  autoOk: true,
  timeFormat: DateFormats.SimpleTime,
  mask: '__:__ _M',
  placeholder: 'HH:MM AM',
  variant: 'keyboardTime'
};
